import type { PageCard } from '@/play/pageTypes'
import { EyeBrushCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'eye-brush',
  number: 6,
  title: 'Eye brush',
  question: 'Do googly eyes feel good painted on like a brush?',
  status: 'open',
  accent: '#fbe6b8',
  CardArt: EyeBrushCardArt,
}
